/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionstitleone3Inputs */

const en_openquestionstitleone3 = /** @type {(inputs: Openquestionstitleone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 open question about your case`)
};

const pt_openquestionstitleone3 = /** @type {(inputs: Openquestionstitleone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ponto a esclarecer sobre o seu processo`)
};

/**
* | output |
* | --- |
* | "1 open question about your case" |
*
* @param {Openquestionstitleone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionstitleone3 = /** @type {((inputs?: Openquestionstitleone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionstitleone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionstitleone3(inputs)
	return pt_openquestionstitleone3(inputs)
});
export { openquestionstitleone3 as "openQuestionsTitleOne" }